<template>
  <input-tags
    v-model="model[name]"
    class="e-tags-input"
    ref="element"
    @update="change"
  >
    <div
      @click="$refs.inputElement && $refs.inputElement.focus()"
      class="tags-input"
      slot-scope="{tag,removeTag,inputEventHandlers,inputBindings }"
    >
      <div class="tags-input__tags">
        <div
          v-for="tag in showedTags"
          class="tags-input__tags__tag"
        >
          <span>{{tag}}</span>
          <a
            v-if="!disabled"
            class="tags-input__tags__tag__remove"
            @click.prevent="removeTag(tag)"
          >×</a>
        </div>
        <div
          v-if="model[name].length > collapseSize"
          class="tags-input__tags__tag"
        >
          <span>+{{model[name].length - showedTags.length}}</span>
        </div>
        <input
          v-if="!disabled"
          class="tags-input__tags__input"
          :placeholder="placeholder"
          v-on="inputEventHandlers"
          v-bind="inputBindings"
          @blur="$refs.element.addTag()"
          ref="inputElement"
        >
      </div>
    </div>
  </input-tags>
</template>

<script>
  // TODO on input detect comma and split that
  // TODO onblur event
  // https://www.npmjs.com/package/vue-tags
  import VueTags from 'vue-tags'

  export default {
    components: {
      'input-tags': VueTags
    },
    name: 'e-tags-input',
    data () {
      return {
        error: null
      }
    },
    props: {
      disablePlaceholderOption: {
        type: Boolean,
        default: true
      },
      onChangeValidation: {
        type: Boolean,
        default: false
      },
      formValidator: null,
      model: {
        type: Object,
        required: true
      },
      tabView: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: null,
        required: true
      },
      validationRule: {
        type: String,
        default: 'string'
      },
      required: {
        type: Boolean,
        default: false
      },
      modalVariableName: {
        type: String,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: 'Добавить'
      },
      collapseSize: {
        type: Number,
        default: Infinity
      }
    },
    computed: {
      showedTags () {
        return this.model[this.name].slice(0, this.collapseSize)
      },
      hasError () {
        if (this.error) {
          return true
        }
        return false
      }
    },
    created () {
      if (this.formValidator) {
        this.formValidator.subscribeInput(this)
      }
    },
    destroyed () {
      if (this.formValidator) {
        this.formValidator.unsubscribeInput(this)
      }
    },
    updated () {
      this.$nextTick(() => {
        this.sendResize()
      })
    },
    methods: {
      onBlur () {

      },
      sendResize () {
        this.$emitter.emit('heightChanged', {
          name: 'e-tags-input',
          el: this.getElement()
        })
      },
      change ($event) {
        this.$emit('change', $event)
        if (this.onChangeValidation) {
          this.validate()
        }
        this.sendResize()
      },
      getElement () {
        return this.$refs.element
      },
      validate () {
        let msg = ''

        if (!Array.isArray(this.model[this.name])) {
          this.model[this.name] = []
        }

        if (this.required) {
          if (this.model[this.name].length < 1) {
            msg += 'Заполните поле'
          }
        }

        if (!msg) {
          let doublePattern = /^(\d*((\.\d{0,}))?(\d))$/i
          let numberPattern = /^\d*$/i
          this.model[this.name].forEach(v => {
            if (this.validationRule === 'double' && !doublePattern.test(v)) {
              msg = 'Допустимы числа вида 0.000, а не ' + v
            } else if (this.validationRule === 'number' && !numberPattern.test(v)) {
              msg = 'Допустимы только целые числа, а не ' + v
            }
          })
        }

        return {
          error: msg,
          tabView: this.tabView,
          name: this.name,
          modalVariableName: this.modalVariableName,
          el: null // this.getElement()
        }
      }
    }
  }
</script>
